__turbopack_context__.v({
  "uncoloredDividerLabel": "CuNwhG_uncoloredDividerLabel",
});
